import { useFormikContext } from 'formik'

import { getEntityActionTypeSelectOptions } from '../../../Entity'
import { FormFieldsContainer } from '../../../Form'
import { FormikEntityActionConfigFields } from '../../../Formik'
import { REQUEST_EDIT_STATUS_FIELD_NAME } from '../RequestEditStatusModal.constants'
import { RequestEditStatusModalStatusField } from '../RequestEditStatusModalStatusField'

function RequestEditStatusModalMassActionFields({
  actionTypes = Object.values(getEntityActionTypeSelectOptions()),
  typeSelectProps,
}) {
  const { errors } = useFormikContext()

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{
          ...typeSelectProps,
          error: errors[REQUEST_EDIT_STATUS_FIELD_NAME],
          options: actionTypes,
        }}
      >
        <RequestEditStatusModalStatusField />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default RequestEditStatusModalMassActionFields
